<template>
  <div class="hireHousePayPlan">
    <div class="user-line">
            <div class="system-title">晓家碧寓内部员工系统--业务员工具箱--出房收款计划生成</div>
        </div>
    <!-- 表单区域：租房信息 -->
    <el-form :model="rentForm" label-width="140px" class="rent-form" ref="rentForm">
      <!-- 第一行：房屋地址单独一行 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="房屋地址">
            <el-input v-model="rentForm.address" disabled placeholder="北京市朝阳区xx小区x号楼x单元101" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第二行：合同起始日，合同到期日 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="合同起始日">
            <el-date-picker 
              v-model="rentForm.startDate" 
              type="date" 
              placeholder="选择日期" 
              style="width: 100%" 
              value-format="yyyy-MM-dd"
              @change="validateEndDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="合同到期日">
            <el-date-picker 
              v-model="rentForm.endDate" 
              type="date" 
              placeholder="选择日期" 
              style="width: 100%" 
              value-format="yyyy-MM-dd"
              @change="validateEndDate"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第三行：押金，房屋租金，租金支付周期 -->
      <el-row :gutter="20">
        <el-col :span="7">
          <el-form-item label="押金(元)">
            <el-input-number 
              v-model="rentForm.deposit" 
              :min="0" 
              :precision="2" 
              style="width: 100%" 
              placeholder="押金"
              @change="handleNumberChange('deposit')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="房屋租金(元)">
            <el-input-number 
              v-model="rentForm.rent" 
              :min="0" 
              :precision="2" 
              style="width: 100%" 
              placeholder="房屋租金"
              @change="handleNumberChange('rent')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="租金支付周期">
            <el-select v-model="rentForm.rentCycle" placeholder="请选择" @change="handleRentCycleChange">
              <el-option label="月付" :value="1"></el-option>
              <el-option label="季付" :value="2"></el-option>
              <el-option label="半年付" :value="3"></el-option>
              <el-option label="年付" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第四行：物业/宽带费，物业费支付周期 -->
      <el-row :gutter="20">
        <el-col :span="7">
          <el-form-item label="物业费(元)">
            <el-input-number 
              v-model="rentForm.propertyFee" 
              :min="0" 
              :precision="2" 
              style="width: 100%" 
              placeholder="物业费"
              @change="handleNumberChange('propertyFee')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="物业/宽带费支付周期" class="long-label">
            <el-select v-model="rentForm.propertyCycle" placeholder="请选择" :disabled="!rentForm.rentCycle">
              <el-option label="月付" :value="1" :disabled="rentForm.rentCycle > 1"></el-option>
              <el-option label="季付" :value="2" :disabled="rentForm.rentCycle > 2"></el-option>
              <el-option label="半年付" :value="3" :disabled="rentForm.rentCycle > 3"></el-option>
              <el-option label="年付" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第五行：水电气押金，宠物押金 -->
      <el-row :gutter="20">
        <el-col :span="7">
          <el-form-item label="水电气押金(元)">
            <el-input-number 
              v-model="rentForm.utilityDeposit" 
              :min="0" 
              :precision="2" 
              style="width: 100%" 
              placeholder="水电气押金"
              @change="handleNumberChange('utilityDeposit')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="宠物押金(元)">
            <el-input-number 
              v-model="rentForm.petDeposit" 
              :min="0" 
              :precision="2" 
              style="width: 100%" 
              placeholder="宠物押金"
              @change="handleNumberChange('petDeposit')"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 按钮栏：右对齐且间距 -->
    <div class="action-bar">
      <el-button @click="resetToDefault">还原默认值</el-button>
      <el-button type="primary" @click="generatePlan">生成付款计划</el-button>
      <el-button @click="clearPlan">清空付款计划</el-button>
    </div>

    <!-- 表格上方：新增收款计划按钮 -->
    <div class="table-header">
      <el-button type="success" size="medium" @click="openAddModal">+ 新增收款计划</el-button>
    </div>

  <!-- 表格：付款计划列表 -->
    <el-table 
    :data="paymentPlanList" 
    border 
    stripe
    style="width: 100%" 
    class="payment-table"
    max-height="400"
    >
    <el-table-column prop="paymentDate" label="付款时间" min-width="120" align="center">
        <template slot-scope="scope">
        {{ scope.row.paymentDate }}
        </template>
    </el-table-column>
    <el-table-column prop="amount" label="付款金额" min-width="100" align="center">
        <template slot-scope="scope">
        ¥ {{ scope.row.amount.toFixed(2) }}
        </template>
    </el-table-column>
    <el-table-column prop="status" label="状态" min-width="100" align="center">
        <template slot-scope="scope">
        <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.status }}</el-tag>
        </template>
    </el-table-column>
    <el-table-column prop="paymentIndex" label="第几次付款" min-width="100" align="center" />
    <el-table-column prop="description" label="说明" width="220" align="left" class-name="description-column">
        <template slot-scope="scope">
        {{ scope.row.description }}
        </template>
    </el-table-column>
    <el-table-column label="操作" min-width="180" align="center">
        <template slot-scope="scope">
        <el-button 
            type="primary" 
            size="medium" 
            class="action-btn"
            @click="openEditModal(scope.row)"
        >修改</el-button>
        <el-button 
            type="danger" 
            size="medium" 
            class="action-btn"
            @click="deleteRow(scope.row)"
        >删除</el-button>
        </template>
    </el-table-column>
    <el-table-column label="排序" min-width="120" align="center">
        <template slot-scope="scope">
        <el-button-group>
            <el-button
            type="primary"
            icon="el-icon-arrow-up"
            size="medium"
            class="sort-btn"
            :disabled="scope.$index === 0"
            @click="moveRow(scope.$index, 'up')"
            ></el-button>
            <el-button
            type="primary"
            icon="el-icon-arrow-down"
            size="medium"
            class="sort-btn"
            :disabled="scope.$index === paymentPlanList.length - 1"
            @click="moveRow(scope.$index, 'down')"
            ></el-button>
        </el-button-group>
        </template>
    </el-table-column>
    </el-table>

    <!-- 新增/修改弹窗 (共用) -->
    <el-dialog :title="modalTitle" :visible.sync="modalVisible" width="500px" @closed="resetModalForm">
      <el-form :model="modalForm" label-width="120px" ref="modalForm" :rules="modalRules">
        <el-form-item label="付款时间" prop="paymentDate">
          <el-date-picker v-model="modalForm.paymentDate" type="date" placeholder="选择日期" style="width: 100%" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item label="付款金额" prop="amount">
          <el-input-number 
            v-model="modalForm.amount" 
            :min="0" 
            :precision="2" 
            style="width: 100%" 
            placeholder="付款金额"
            @change="handleModalNumberChange('amount')"
          />
        </el-form-item>
        
        <el-form-item label="状态" prop="status">
            <el-select v-model="modalForm.status" placeholder="请选择状态" style="width: 100%">
                <el-option label="待付" value="待付"></el-option>
                <el-option label="已完成" value="已完成"></el-option>
                <el-option label="部分收款" value="部分收款"></el-option>
                <el-option label="逾期" value="逾期"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="第几次付款" prop="paymentIndex">
          <el-input-number 
            v-model="modalForm.paymentIndex" 
            :min="1" 
            :step="1" 
            style="width: 100%" 
            placeholder="第几次"
            @change="handleModalNumberChange('paymentIndex')"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="modalVisible = false">取消</el-button>
        <el-button type="primary" @click="saveModal">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { smwxMethod_9_001 } from "@/api/9小程序管理/9_001_smwx.js";
import detailModal from "./components/update_repair_modal/update_repair_modal.vue";
import addRepairModal from "./components/add_repair_modal/add_repair_modal.vue";
import updateHouseModal from "./components/update_repair_modal/update_repair_modal.vue";
import topUserV2 from "@/views/components/topUserV2/topUserV2.vue";
import { generatePaymentPlan, validateRentForm } from "./paymentPlanGenerator";

export default {
  name: "topUser",
  components: { topUserV2, detailModal, addRepairModal, updateHouseModal },
  created() {
    this.init();
    // 初始化模拟数据 - 注释掉，使用生成的数据
    // this.paymentPlanList = [
    //   { id: 1, paymentDate: '2025-04-01', amount: 3500, status: '待支付', paymentIndex: 1 },
    //   { id: 2, paymentDate: '2025-07-01', amount: 3500, status: '已付', paymentIndex: 2 },
    //   { id: 3, paymentDate: '2025-10-01', amount: 3500, status: '逾期', paymentIndex: 3 },
    //   { id: 4, paymentDate: '2026-01-01', amount: 3500, status: '待支付', paymentIndex: 4 },
    //   { id: 5, paymentDate: '2026-04-01', amount: 3500, status: '待支付', paymentIndex: 5 },
    // ];
    
    // 可以生成一个示例数据
    this.generateExamplePlan();
  },
  computed: {},
  data() {
    return {
      // 租房表单数据
      rentForm: {
        address: '北京市朝阳区xx小区x号楼x单元101',
        startDate: '2025-01-14',
        endDate: '2025-08-17',
        deposit: 2000,
        rent: 3500,
        propertyFee: 300,
        rentCycle: 2, // 默认季付
        propertyCycle: 2,
        utilityDeposit: 500,
        petDeposit: 0,
      },
      // 付款计划列表
      paymentPlanList: [],
      // 弹窗相关
      modalVisible: false,
      modalTitle: '新增付款计划',
      modalForm: {
        id: null,
        paymentDate: '',
        amount: 0,
        status: '待支付',
        paymentIndex: 1,
        description: ''
      },
      modalRules: {
        paymentDate: [{ required: true, message: '请选择付款时间', trigger: 'change' }],
        amount: [{ required: true, message: '请输入付款金额', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        paymentIndex: [{ required: true, message: '请输入第几次付款', trigger: 'blur' }],
      },
      editingId: null,
      // 在modalRules上面或下面的data中，修改状态选项
      modalForm: {
        id: null,
        paymentDate: '',
        amount: 0,
        status: '待付', // 默认改为待付
        paymentIndex: 1,
        description: ''
        },
    };
  },

  mounted() {},
  watch: {},
  methods: {
    init() {
      // 初始化逻辑
    },

    // 生成示例数据
    generateExamplePlan() {
      try {
        if (this.rentForm.startDate && this.rentForm.endDate) {
          this.paymentPlanList = generatePaymentPlan(this.rentForm);
        }
      } catch (error) {
        console.log('示例数据生成失败:', error.message);
      }
    },

    // 处理数字输入框负数问题
    handleNumberChange(field) {
      if (this.rentForm[field] < 0) {
        this.$set(this.rentForm, field, 0);
      }
    },

    // 处理弹窗数字输入框负数问题
    handleModalNumberChange(field) {
      if (this.modalForm[field] < 0) {
        this.$set(this.modalForm, field, 0);
      }
      if (field === 'paymentIndex' && this.modalForm[field] < 1) {
        this.$set(this.modalForm, field, 1);
      }
    },

    // 验证合同到期日不小于起始日
    validateEndDate() {
      if (this.rentForm.startDate && this.rentForm.endDate) {
        if (this.rentForm.endDate < this.rentForm.startDate) {
          this.$alert('合同到期日不能小于合同起始日，请重新选择', '日期错误', {
            confirmButtonText: '确定',
            type: 'warning'
          });
        }
      }
    },

    // 租金周期变化时，物业周期自动跟随且不可小于租金周期
    handleRentCycleChange(val) {
      if (val > this.rentForm.propertyCycle) {
        this.$set(this.rentForm, 'propertyCycle', val);
      }
    },

    // 还原默认值
    resetToDefault() {
      this.rentForm = {
        address: '北京市朝阳区xx小区x号楼x单元101',
        startDate: '2025-01-14',
        endDate: '2025-08-17',
        deposit: 2000,
        rent: 3500,
        propertyFee: 300,
        rentCycle: 2,
        propertyCycle: 2,
        utilityDeposit: 500,
        petDeposit: 0,
      };
      this.$message.success('已还原默认值');
    },

    // 生成付款计划
    generatePlan() {
      try {
        // 验证表单
        const validation = validateRentForm(this.rentForm);
        if (!validation.valid) {
          this.$message.error(validation.message);
          return;
        }

        // 生成付款计划
        this.paymentPlanList = generatePaymentPlan(this.rentForm);
        
        // 计算总金额
        const totalAmount = this.paymentPlanList.reduce((sum, item) => sum + item.amount, 0);
        
        this.$message.success(`付款计划生成成功，共 ${this.paymentPlanList.length} 期，总金额 ¥${totalAmount.toFixed(2)}`);
        
        // 在控制台输出详细计划
        console.log('生成的付款计划:', this.paymentPlanList);
      } catch (error) {
        this.$message.error(error.message || '生成付款计划失败');
      }
    },

    // 清空付款计划
    clearPlan() {
      this.$confirm('确认清空所有付款计划吗？', '提示', {
        type: 'warning',
      }).then(() => {
        this.paymentPlanList = [];
        this.$message.info('已清空付款计划');
      }).catch(() => {});
    },

    // 辅助：日期加月
    addMonths(dateStr, months) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      d.setMonth(d.getMonth() + months);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 打开新增弹窗
    openAddModal() {
      this.modalTitle = '新增付款计划';
      this.modalForm = {
        id: null,
        paymentDate: '',
        amount: 0,
        status: '待支付',
        paymentIndex: this.paymentPlanList.length + 1,
        description: '手动添加'
      };
      this.editingId = null;
      this.modalVisible = true;
    },

    // 打开编辑弹窗
    openEditModal(row) {
      this.modalTitle = '修改付款计划';
      this.modalForm = { ...row };
      this.editingId = row.id;
      this.modalVisible = true;
    },

    // 保存弹窗数据
    saveModal() {
      this.$refs.modalForm.validate((valid) => {
        if (!valid) return;
        if (this.editingId) {
          const index = this.paymentPlanList.findIndex((item) => item.id === this.editingId);
          if (index !== -1) {
            this.$set(this.paymentPlanList, index, { 
              ...this.modalForm, 
              id: this.editingId,
              amount: Number(this.modalForm.amount)
            });
          }
          this.$message.success('修改成功');
        } else {
          const newRow = {
            ...this.modalForm,
            id: Date.now(),
            amount: Number(this.modalForm.amount),
            description: this.modalForm.description || '手动添加'
          };
          this.paymentPlanList.push(newRow);
          this.$message.success('新增成功');
        }
        this.modalVisible = false;
      });
    },

    // 重置弹窗表单
    resetModalForm() {
      if (this.$refs.modalForm) {
        this.$refs.modalForm.clearValidate();
      }
    },

    // 删除行
    deleteRow(row) {
      this.$confirm('确认删除该条付款计划吗？', '提示', {
        type: 'warning',
      }).then(() => {
        const index = this.paymentPlanList.findIndex((item) => item.id === row.id);
        if (index !== -1) {
          this.paymentPlanList.splice(index, 1);
          this.$message.success('删除成功');
        }
      }).catch(() => {});
    },

    // 上移/下移
    moveRow(index, direction) {
      const newList = [...this.paymentPlanList];
      if (direction === 'up' && index > 0) {
        [newList[index - 1], newList[index]] = [newList[index], newList[index - 1]];
      } else if (direction === 'down' && index < newList.length - 1) {
        [newList[index], newList[index + 1]] = [newList[index + 1], newList[index]];
      } else {
        return;
      }
      this.paymentPlanList = newList;
    },
    // 获取状态对应的标签类型
    getStatusType(status) {
    const statusMap = {
        '待付': 'danger',
        '待支付': 'danger',
        '已完成': 'success',
        '已付': 'success',
        '部分收款': 'warning',
        '逾期': 'danger'
    };
    return statusMap[status] || 'info'; // 默认黑色（info）
    },
  },
};
</script>
<style lang="scss">
@import '9_002_hireHousePayPlan.scss';
</style>